import theme from '@/flowbite-theme';
import { installNinjaCsrfInterceptors, prefetchNinjaCsrf } from '@/libs/ninja/csrf';
import router from '@/router';
import { store } from '@/store/store';
import { Flowbite } from 'flowbite-react';
import { useEffect } from 'react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import AuthProvider from './providers/auth-provider';

const App = () => {
  useEffect(() => {
    installNinjaCsrfInterceptors();
    prefetchNinjaCsrf();
  }, []);
  return (
    <Provider store={store}>
      <Flowbite theme={{ theme }}>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </Flowbite>
      <ToastContainer
        bodyClassName={() => 'text-sm font-white font-med block p-3'}
        position="bottom-left"
        autoClose={3000}
      />
    </Provider>
  );
};

export default App;
